import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  // file upload is optional — not used currently
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // 清除该字段的错误信息
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // 验证邮箱格式
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // 验证所有字段并返回错误信息
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.subject) {
      newErrors.subject = "Please select a subject";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证表单
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // 滚动到第一个错误字段
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    // 模拟表单提交
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
      // clear any file selection (not used)
      setIsSubmitting(false);

      // 滚动到顶部显示成功消息
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // 5秒后隐藏成功消息
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1000);
  };

  return (
    <div className="contact">
      <Header />

      <main className="contact-main">
        <div className="container contact-inner">
          <aside className="contact-left">
            <div className="left-image">
              <img src="/main/main2-1.webp" alt="Cartnovabin" />
              <div className="left-overlay">
                <h2 className="left-title">Cartnovabin</h2>
                <div className="left-copy">
                  <p>
                    <strong>Cartnovabin</strong> is your new favorite online
                    designer women's shoe store! We are open processing and
                    shipping orders daily except weekends and holidays!
                  </p>
                  <p>
                    If you are looking for the latest styles in women's shoes to
                    stay ahead of the trends - then welcome! Have Cartnovabin
                    shoe questions? Want to collaborate? Just want to talk
                    shoes? We're here to help - go ahead and drop us a line!
                  </p>
                  <h4>Cartnovabin Hours of Operation</h4>
                  <p>Monday - Friday 9am - 5pm Pacific Time</p>
                  <p>(833) 855-2424</p>
                  <p>
                    <a href="mailto:cart@cartnovabin.shop">
                      cart@cartnovabin.shop
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </aside>

          <section className="contact-right">
            <h2 className="contact-heading">Get in Touch</h2>

            {showSuccess && (
              <div className="form-success">Message sent successfully.</div>
            )}

            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="form-row two">
                <label>
                  Name
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    aria-invalid={!!errors.name}
                  />
                  {errors.name && (
                    <div className="field-error">{errors.name}</div>
                  )}
                </label>

                <label>
                  Email *
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    aria-invalid={!!errors.email}
                  />
                  {errors.email && (
                    <div className="field-error">{errors.email}</div>
                  )}
                </label>
              </div>

              <label className="form-row">
                Your message
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your message"
                  rows={8}
                  value={formData.message}
                  onChange={handleInputChange}
                  aria-invalid={!!errors.message}
                />
                {errors.message && (
                  <div className="field-error">{errors.message}</div>
                )}
              </label>

              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Submit Now"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
